import { render, staticRenderFns } from "./ProductModelUpdateScreen.vue?vue&type=template&id=3d825ef3&"
import script from "./ProductModelUpdateScreen.vue?vue&type=script&lang=js&"
export * from "./ProductModelUpdateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports